import { createAsyncThunk } from '@reduxjs/toolkit';
import { getTags as getQuestAppletsService } from './services';

const GET_TAGS = 'GET_TAGS';
export const getTags = createAsyncThunk(GET_TAGS, getQuestAppletsService);
